import React, { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { SectionTitle, Btn, Modal, Field, TextArea, EmptyState, SearchBar, normalize } from "@/components/Brutal";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Trees } from "lucide-react";

const empty = { nome: "", municipio: "", descricao: "" };

export default function Communities() {
  const { hasRole } = useAuth();
  const canEdit = hasRole("almoxarife");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async () => { setLoading(true); const { data } = await api.get("/communities"); setItems(data); setLoading(false); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/communities/${editing.id}`, form);
      else await api.post("/communities", form);
      toast.success(editing ? "Atualizado" : "Criado");
      setOpen(false); setEditing(null); setForm(empty); load();
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
  };
  const remove = async (id) => { if (!confirm("Excluir?")) return; try { await api.delete(`/communities/${id}`); toast.success("Excluído"); load(); } catch (err) { toast.error(formatError(err.response?.data?.detail)); } };

  const filtered = items.filter((c) => {
    if (!q) return true;
    const nq = normalize(q);
    return normalize(c.nome).includes(nq) || normalize(c.municipio).includes(nq) || normalize(c.descricao).includes(nq);
  });

  return (
    <div data-testid="communities-page">
      <SectionTitle action={canEdit && <Btn onClick={() => { setEditing(null); setForm(empty); setOpen(true); }}><Plus className="w-4 h-4" />Nova Comunidade</Btn>}>
        Comunidades · <Trees className="inline w-5 h-5 -mt-1" />
      </SectionTitle>
      <div className="mb-4 flex gap-2">
        <SearchBar value={q} onChange={setQ} placeholder="Buscar por nome, município ou descrição..." testid="communities-search" />
      </div>
      <div className="brutal-card overflow-x-auto">
        <table className="brutal-table">
          <thead><tr><th>Nome</th><th>Município</th><th>Descrição</th>{canEdit && <th className="w-24">Ações</th>}</tr></thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="text-center py-8 text-[#777] font-mono-data">Carregando...</td></tr>}
            {!loading && filtered.length === 0 && <EmptyState message={q ? "Nenhum resultado." : "Nenhuma comunidade."} cols={canEdit ? 4 : 3} />}
            {filtered.map((c) => (
              <tr key={c.id}>
                <td className="font-medium">{c.nome}</td>
                <td className="text-sm">{c.municipio || "—"}</td>
                <td className="text-sm text-[#555] truncate max-w-md">{c.descricao || "—"}</td>
                {canEdit && <td><div className="flex gap-1">
                  <button onClick={() => { setEditing(c); setForm({ ...c }); setOpen(true); }} className="p-1.5 hover:bg-[#FF4F00] hover:text-white border border-[#111]"><Pencil className="w-3.5 h-3.5" /></button>
                  <button onClick={() => remove(c.id)} className="p-1.5 hover:bg-[#E60000] hover:text-white border border-[#111]"><Trash2 className="w-3.5 h-3.5" /></button>
                </div></td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Editar Comunidade" : "Nova Comunidade"} size="md">
        <form onSubmit={submit} className="grid grid-cols-2 gap-4">
          <Field label="Nome *" required value={form.nome} onChange={(v) => setForm({ ...form, nome: v })} colspan />
          <Field label="Município" value={form.municipio} onChange={(v) => setForm({ ...form, municipio: v })} colspan />
          <TextArea label="Descrição" value={form.descricao} onChange={(v) => setForm({ ...form, descricao: v })} />
          <div className="col-span-2 flex justify-end gap-2 pt-2 border-t-2 border-[#111]">
            <Btn type="button" variant="secondary" onClick={() => setOpen(false)}>Cancelar</Btn>
            <Btn type="submit">{editing ? "Salvar" : "Criar"}</Btn>
          </div>
        </form>
      </Modal>
    </div>
  );
}
